import { useIntl } from 'react-intl';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { useCurrentProjectId } from 'hooks/path-params-extraction.hooks';
import { BridgedAlert as Alert } from 'components/common/feedback/bridged-alert';
import { useCuratedProjectsTree } from 'stores/rq/projects';
import { isParentProject } from 'utils/sub-project.utils';

interface Props {
  pageType: 'configuration' | 'cost';
}

const SubProjectsNotAffectedAlert: React.FunctionComponent<Props> = ({ pageType }) => {
  const { projects } = useCuratedProjectsTree();
  const currentProjectId = useCurrentProjectId();
  const intl = useIntl();
  const isInParentProject = useMemo(
    () => !!currentProjectId && isParentProject(projects[currentProjectId]),
    [projects, currentProjectId]
  );
  const messageId = `project.settings.sub-project.wont-be-affected.${pageType}.warning`;

  return isInParentProject ? (
    <Alert
      showIcon
      message={intl.formatMessage({ id: messageId })}
      type="warning"
      data-e2e={'sub-projects-not-affected-alert'}
    />
  ) : null;
};

export default observer(SubProjectsNotAffectedAlert);
